import type { Placement } from '@floating-ui/react';

// ~22.5° from vertical: inside this band the label sits mostly above/below the
// node and a top/bottom bubble clears it. Outside it (e.g. 60° / 120° diagonals)
// a rotated label's inward half still occupies the strip above the node, so a
// top bubble overlaps — open left/right instead.
const NEAR_VERTICAL_COS = Math.sin(Math.PI / 8);

/**
 * Node labels sit outward along the layout ray (SVG degrees: 0 = right,
 * 90 = down). Pick a Floating UI side that stays clear of that label.
 */
export const tooltipPlacementAwayFromRay = (rayAngle: number): Placement => {
  const radians = (rayAngle * Math.PI) / 180;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);

  if (Math.abs(cos) >= NEAR_VERTICAL_COS) {
    return cos >= 0 ? 'left' : 'right';
  }
  return sin >= 0 ? 'top' : 'bottom';
};
